
import Filesystem from '@/components/Folders/Filesystem'
import FoldersMixin from '@/mixins/Folders/FoldersMixin'
import LoadingIcon from '@/components/common/LoadingIcon'

export default {
    components: {
        Filesystem
    },
    mixins: [FoldersMixin],
    middleware: 'isSubscribe',
    data () {
        return {
            nodes: null,
            pagination: null,
            roots: [],
            folder: null,
            error: null,
            searchTxt: '',
            form: new this.$vForm({}),
            toast: null,
            msgs: {
                success: null,
                error: null
            },
            params: {
                sort_as: 'asc',
                sort_by: 'name',
                page: undefined,
                exact: undefined
            }
        }
    },
    watch: {
        'msgs.success' (value) {
            if (value && this.toast !== null) {
                this.$toast.update(this.toast, {
                    content: value,
                    options: {
                        type: 'success',
                        timeout: 2000,
                        icon: true,
                        closeButton: 'button',
                        closeOnClick: false,
                        draggable: true
                    }
                })
            }
        },
        'msgs.error' (value) {
            if (value && this.toast !== null) {
                this.$toast.update(this.toast, {
                    content: value,
                    options: {
                        type: 'error',
                        timeout: 2500,
                        icon: true,
                        closeButton: 'button',
                        closeOnClick: false,
                        draggable: true
                    }
                })
            }
        }
    },
    mounted () {
        const search = this.$route.query.search
        this.$store.commit('folders/setSearchText', search)
        this.$store.commit('folders/setIsLoading', true)

        this.refreshParams()

        if (this.$store.getters['folders/searchText']) {
            this.search(search)
        } else {
            this.load(this.$route.params.hash)
        }
    },
    methods: {
        createFolder ({ name, folder }) {
            this.send('post', '/nodes', { name, folder, type: 'd' }, 'تم الانشاء بنجاح')
        },
        renameFolder ({ id, name }) {
            this.send('patch', '/nodes/' + id, { name }, 'تم التعديل بنجاح')
        },
        moveNode ({ node, folder }) {
            const selectedNodes = this.$store.getters['folders/selectedNodes']
            if (selectedNodes.length > 0) {
                this.send('post', '/bulk', { op: 'move', folder, nodes: selectedNodes }, 'تم النقل بنجاح')
            } else {
                this.send('patch', '/move/' + node.id, { folder }, 'تم النقل بنجاح')
            }
        },
        copyNode ({ node, folder }) {
            const selectedNodes = this.$store.getters['folders/selectedNodes']
            if (selectedNodes.length > 0) {
                this.send('post', '/bulk', { op: 'copy', folder, nodes: selectedNodes }, 'تم النسخ بنجاح')
            } else {
                this.send('patch', '/copy/' + node.id, { folder }, 'تم النسخ بنجاح')
            }
        },
        trashNode (node) {
            const selectedNodes = this.$store.getters['folders/selectedNodes']
            if (selectedNodes.length > 0) {
                this.send('post', '/bulk', { op: 'trash', nodes: selectedNodes }, 'تم الحذف بنجاح')
            } else {
                this.send('patch', '/trash/' + node.id, null, 'تم الحذف بنجاح')
            }
        },
        restoreNode (node) {
            const selectedNodes = this.$store.getters['folders/selectedNodes']
            if (selectedNodes.length > 0) {
                this.send('post', '/bulk', { op: 'restore', nodes: selectedNodes }, 'تمت الاستعادة بنجاح')
            } else {
                this.send('patch', '/restore/' + node.id, null, 'تمت الاستعادة بنجاح')
            }
        },
        deleteNode (node) {
            const selectedNodes = this.$store.getters['folders/selectedNodes']
            if (selectedNodes.length > 0) {
                this.send('post', '/bulk', { op: 'delete', nodes: selectedNodes }, 'تم الحذف نهائيا بنجاح')
            } else {
                this.send('delete', '/nodes/' + node.id, null, 'تم الحذف نهائيا بنجاح')
            }
        },
        showInFolder (node) {
            this.$store.commit('folders/setSearchText', null)
            this.pushNodes(node.parent_id)
        },
        refresh (loading = false) {
            this.$store.commit('folders/setSearchText', null)
            this.$store.commit('folders/clearSelectedNodes')
            this.load(this.folder?.id, loading)
        },
        refreshParams () {
            const params = ['sort_by', 'sort_as', 'search'].reduce((o, k) => { o[k] = this.$route.query[k]; return o }, {})
            Object.assign(this.params, params)
        },
        showFolder (id) {
            this.$store.commit('folders/clearSelectedNodes')
            delete this.params.search
            delete this.params.page
            if (this.folder?.id !== undefined && (id !== this.folder?.id || this.$store.getters['folders/isTrash'])) {
                if (this.$store.getters['folders/isTrash'] && id === 'trash') {
                    return
                }
                this.$store.commit('folders/setSearchText', null)
                this.$store.commit('folders/setIsLoading', true)
                this.pushNodes(id, this.params).finally(() => {
                    this.$store.commit('folders/setIsLoading', false)
                })
            } else if (this.$store.getters['folders/searchText']) {
                this.$store.commit('folders/setSearchText', null)
                this.refresh()
            } else if (this.folder?.id === undefined) {
                this.pushNodes(this.roots[0]?.id, this.params)
            } else {
                this.refresh(true)
            }
        },
        showOperationLoading () {
            this.toast = this.$toast('جار العمل', {
                timeout: false,
                closeButton: false,
                icon: LoadingIcon,
                rtl: true,
                closeOnClick: false,
                draggable: false
            })
        },
        search (search) {
            this.searchTxt = search
            if (search) {
                this.$store.commit('folders/setSearchText', search)
                this.$store.commit('folders/setIsLoading', true)

                const hash = this.$route.params.hash
                const params = Object.assign({ ...this.params }, { folder: hash || undefined })
                params.search = search
                params.extra = ['path']

                this.$axios.get('/v1/fs/search', { params })
                    .then(({ data }) => {
                        if (this.$store.getters['folders/searchText'] && data?.folder) {
                            this.nodes = data.data
                            this.folder = data?.folder
                            this.pagination = data?.meta
                        }
                    })
                    .catch((e) => {
                        this.msgs.error = 'حصل خطأ الرجاء المحاولة مرة اخرى'
                        throw e
                    })
                    .finally(() => {
                        this.$store.commit('folders/setIsLoading', false)
                        this.params.exact = undefined
                    })
            } else {
                this.$store.commit('folders/setSearchText', null)
                this.refresh()
            }
        },
        updateParams (params) {
            Object.assign(this.params, params)

            if (this.$store.getters['folders/searchText']) {
                this.search(this.searchTxt)
            } else {
                this.pushNodes(this.$route.params.hash, this.params, 'replace')
                this.refresh()
            }
        },
        load (id, loading = true) {
            if (loading) {
                this.$store.commit('folders/setIsLoading', true)
            }
            const params = { ...this.params }
            this.listNodes(id, params)
                .then(({ data }) => {
                    if (data?.folder) {
                        this.nodes = data.data
                        this.roots = data?.roots
                        this.folder = data?.folder
                        this.pagination = data?.meta
                        this.$store.commit('folders/setRootFolders', data?.roots)
                        this.$store.commit('folders/setFolder', data?.folder)
                    }
                })
                .catch((e) => {
                    throw e
                })
                .finally(() => this.$store.commit('folders/setIsLoading', false))
        },
        send (method, url, data, successMsg) {
            this.form.clear()
            this.form.update(data)
            this.showOperationLoading()
            return this.form[method](this.localePath('/v1/fs' + url))
                .then(({ _ }) => {
                    this.msgs.success = successMsg
                    this.refresh()
                })
                .catch((e) => {
                    if (this.form.errors.hasAny('name')) {
                        this.msgs.error = this.form.errors.get('name')
                    } else {
                        this.msgs.error = this.$t('general error please try again')
                        this.$store.commit('folders/setIsLoading', false)
                        throw e
                    }
                })
                .finally(() => {
                    this.msgs.success = ''
                    this.msgs.error = ''
                })
        }
    },
    head () {
        return {
            title: (this.folder?.name || this.$t('my folders page'))
        }
    }
}
